var _excluded = ["size", "children", "appearance", "iconPosition", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Button as DomainStandardButton, LinkButton as DomainLinkButton } from '@domain-group/fe-co-button';
import * as styles from './button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var appearanceMap = {
  primary: 'highlight',
  secondary: 'regular',
  outline: 'outline',
  outlineTrim: 'outline',
  outlineMedium: 'outline',
  outlineSelected: 'outline',
  ghost: 'regular',
  ghostNeutral: 'regular',
  transparent: 'lowlight',
  standard: 'highlight',
  accent: 'highlight',
  secondaryNeutral: 'outline',
  neutralFilled: 'regular'
};
var sizeMap = {
  small: {
    domainSize: 'small',
    style: styles.smallButton,
    iconOnlyStyle: styles.iconOnlySmall
  },
  regular: {
    domainSize: 'regular',
    style: styles.button,
    iconOnlyStyle: styles.iconOnly
  },
  large: {
    domainSize: 'large',
    style: styles.largeButton,
    iconOnlyStyle: styles.iconOnlyLarge
  },
  responsive: {
    domainSize: 'small',
    style: styles.responsiveButton,
    iconOnlyStyle: styles.iconOnlyResponsive
  }
};
function buildProps(_ref) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$isLink = _ref2.isLink,
    isLink = _ref2$isLink === void 0 ? false : _ref2$isLink;
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    children = _ref.children,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var isIconOnly = !children;
  var mappedSize = sizeMap[size] || sizeMap.regular;
  return _objectSpread(_objectSpread({}, props), {}, {
    css: [isLink && styles.linkButton, mappedSize.style, styles.appearance[appearance] || appearanceMap.primary, isIconOnly && mappedSize.iconOnlyStyle],
    size: mappedSize.domainSize,
    appearance: appearanceMap[appearance],
    iconPosition,
    className,
    children
  });
}
var Button = props => ___EmotionJSX(DomainStandardButton, buildProps(props));
var LinkButton = props => ___EmotionJSX(DomainLinkButton, buildProps(props, {
  isLink: true
}));
export { Button, LinkButton };